/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow-left': {
    width: 27,
    height: 26,
    viewBox: '0 0 27 26',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M9.258 14.32a1.857 1.857 0 01.03-2.703l5.29-4.874a.619.619 0 11.838.91l-5.29 4.874a.619.619 0 00-.01.901l5.18 4.991a.62.62 0 11-.86.892L9.259 14.32z" _fill="#fff"/>'
  }
})
